import Vue from 'vue';
import VueApexCharts from 'vue-apexcharts';

Vue.use(VueApexCharts);
Vue.component('apexchart', VueApexCharts);

// Apex Charts plugin
// Apex docs: https://apexcharts.com/docs/installation/
// Vue specific docs: https://apexcharts.com/docs/vue-charts/
